// extracted by mini-css-extract-plugin
export default {"contentContainer":"style_contentContainer__GnPg+"};